import { createRouter, createWebHistory } from 'vue-router';

// import Default from '@/module/Home/page/Default.vue';
import Notfound from '@/module/Static/Notfound/page/Notfound.vue';

// page
import Home from '@/module/Home/page/Home.vue';
import LineLogin from "@/module/LineLogin/page/LineLogin.vue";
import verifyPage from "@/module/Register/verifyUser/verifypage.vue";
import Privilege from '@/module/Privilege/page/Privilege.vue';
import Register from '@/module/Register/page/Register.vue';
import Profile from '@/module/Profile/page/Profile.vue';
import Campaign from '@/module/Detail/page/Campaign.vue';
import TermAndCondition from '@/module/TermAndConditions/page/TermAndCondition.vue';
import HistoryRedeem from '@/module/History/page/HistoryRedeem.vue'
import EditProfile from '@/module/EditProfile/page/EditProfile.vue'
import Mission from '../module/Mission/page/Mission.vue';
import Getfriend from '../module/Mission/page/Getfriend.vue';
import GetFriendsms from '../module/Mission/page/GetFriendsms.vue';
// import History from '@/module/History/page/History.vue'
import TransferPoint from '@/module/TransferPoint/page/TransferPoint.vue';
import Checkin from '@/module/Mission/page/Checkin.vue';
import ContactUs from '@/module/ContactUs/page/ContactUs.vue';
import ForgetPassword from '@/module/ForgetPassword/page/ForgetPassword.vue';
import TransferMAAI from '../module/TransferMAAI/page/TransferMAAI.vue'
import FooterBottom from '@/module/Example/page/FooterBottom.vue';

const routes = [
    {
        path: '/',
        name: 'default',
        component: Home
    },
    {
        path: '/home',
        name: 'Home',
        component: Home
    },
    {
        path: "/linelogin",
        name: "linelogin",
        component: LineLogin,
    },
    {
        path: "/verifypage",
        name: "verifypage",
        component: verifyPage,
    },
    {
        path: '/privilege',
        name: 'privilege',
        component: Privilege,
    }, {
        path: "/register",
        name: "register",
        component: Register,
    },
    {
        path: '/campaign/:campaignId',
        name: 'campaign_detail',
        component: Campaign,
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile
    },
    {
        path: "/termandcondition",
        name: "TermAndCondition",
        component: TermAndCondition
    },
    {
        path: '/register/getfrined/:refcode',
        name: 'register_getfriend',
        component: TermAndCondition,
    },
    {
        path: "/history/redeem",
        name: "HistoryRedeem",
        alias: "/carthistory",
        component: HistoryRedeem
    },
    {
        path: "/profile/edit",
        name: "EditProfile",
        component: EditProfile
    },
    {
        path: "/mission",
        name: "mission",
        component: Mission
    },
    {
        path: "/getfriend/:key",
        name: "getfriend",
        component: Getfriend
    },
    {
        path: "/getfriendsms/:key",
        name: "getfriendsms",
        component: GetFriendsms
    },
    {
        path: "/checkin/:key",
        name: "Checkin",
        component: Checkin
    },
    {
        path: "/transfer/point",
        name: "TransferPoint",
        component: TransferPoint
    },
    {
        path: "/contactus",
        name: "ContactUs",
        component: ContactUs
    },
    {
        path: "/forgetpassword",
        name: "ForgetPassword",
        component: ForgetPassword
    },
    {
        path: "/transfermaai",
        name: "transfermaai",
        component: TransferMAAI
    },
    {
        path: "/example/footerbottom",
        name: "example",
        component: FooterBottom
    },
    // {
    //     path: "/history",
    //     name: "History",
    //     component: History
    // },
    {
        path: '/:catchAll(.*)',
        component: Notfound,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
